import InfoCard from "../../Common/InfoCard/Infocard";

const ErrorPage = () => {
  return (
    <div className="w-full flex justify-center bg-primary h-screen">
      <div className="flex flex-col justify-center items-center">
        <div className=" fill-none stroke-primary text-center">
          <InfoCard
            text="Oops, it seems you've ventured off the beaten path! Our apologies, but the page you're looking for appears to be taking a break. Don't worry; we'll help you get back on track in no time!"
            heading="Oops, Page not found!"
            link={{ linkTo: "/", text: "Take me home." }}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
